/**
 * @generated SignedSource<<7dde728e5c4c5ff075312baa9da3ad70>>
 * @relayHash 48f22c23828bd55e7b95ab37eb5b04e8
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 48f22c23828bd55e7b95ab37eb5b04e8

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DestroyQuestionInput = {
  clientMutationId?: string | null;
  questionId: string;
};
export type QuestionDestroyMutation$variables = {
  input: DestroyQuestionInput;
};
export type QuestionDestroyMutation$data = {
  readonly destroyQuestion: {
    readonly examVersion: {
      readonly dbQuestions: ReadonlyArray<{
        readonly id: string;
        readonly index: number;
      }>;
      readonly id: string;
    };
  } | null;
};
export type QuestionDestroyMutation = {
  response: QuestionDestroyMutation$data;
  variables: QuestionDestroyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DestroyQuestionPayload",
    "kind": "LinkedField",
    "name": "destroyQuestion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExamVersion",
        "kind": "LinkedField",
        "name": "examVersion",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Question",
            "kind": "LinkedField",
            "name": "dbQuestions",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "index",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuestionDestroyMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuestionDestroyMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "48f22c23828bd55e7b95ab37eb5b04e8",
    "metadata": {},
    "name": "QuestionDestroyMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ca8931242701ce4d4ad78a0909dea25e";

export default node;
